// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__37k4-","addWidgetButton":"Header_addWidgetButton__1LTKV","dashboardTabs":"Header_dashboardTabs__12imV","active":"Header_active__1b_fw"};